import request from '@/utils/request'

// 查询客户订购流量池详情
export function findAgentSubscribeTrafficPoolOrder(id) {
  return request({
    url: `/agent_subscribe_traffic_pool_orders/${id}`,
    method: 'get'
  })
}
